import React, { useState } from "react";
import { Box, Modal, Typography, TextField, Button, IconButton } from "@mui/material";
import { showSuccess, showError } from "../../../../components/ModernSnackbar";
import { forgotPassword } from "../../../../services/api/fytnServices";
import CloseIcon from '@mui/icons-material/Close';
import styles from "./AuthForm.module.css"; // Adjust the path as necessary

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: 400 },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

const ForgotPassword = ({ open, onClose }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  // Email validation regex
  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleVerify = async () => {
    setLoading(true);
    try {
      const res=await forgotPassword(email);
      console.log("res",res);
              showSuccess("Reset link sent to your email.");
      onClose();
    } catch (err) {
              showError(
        err.response?.data?.message || "Failed to send reset link."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" mb={2}>
          Forgot Password
        </Typography>
        <TextField
          label="Enter your email"
          fullWidth
          value={email}
          onChange={e => setEmail(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Button
          className={styles.btn}
          fullWidth
          onClick={handleVerify}
          disabled={loading || !isEmailValid}
          sx={{
            mt: 1,
            background: 'linear-gradient(to right, #667eea, #764ba2)',
            color: 'white',
            fontWeight: 600,
            fontSize: 16,
            borderRadius: 2,
            boxShadow: '0 6px 15px rgba(118, 75, 162, 0.3)',
            '&:hover': {
              background: 'linear-gradient(to right, #667eea, #764ba2)',
              filter: 'brightness(1.08)'
            }
          }}
        >
          {loading ? "Sending..." : "Verify"}
        </Button>
      </Box>
    </Modal>
  );
};

export default ForgotPassword;
